export const USER_DB_REF = 'user' as const;

export const PENDING_PURCHASE_SESSION_DB_REF = 'pendingPurchaseSession' as const;

export const PROCESSING_PAYMENTS_DB_REF = 'processingPayments' as const;

export const PROMO_CODE_DB_REF = 'promoCodes';